import cn from 'classnames'
import Processing from 'ext-ui/components/Processing/Processing'
import React, { ReactElement, ReactNode } from 'react'
import SvgAlertCircledFilled from 'src/components/Svgs/SvgAlertCircledFilled'
import SvgCheckFilled from 'src/components/Svgs/SvgCheckFilled'
import SvgLinked from 'src/components/Svgs/SvgLinked'
import SvgUpdate from 'src/components/Svgs/SvgUpdate'

import style from './IntegrationCardFooter.style'

export type IntegrationCardIndicatorKind =
  | 'connect'
  | 'connected'
  | 'incomplete'
  | 'loading'
  | 'manage'

export type IntegrationCardIndicatorProps = {
  kind: IntegrationCardIndicatorKind
  label: string
  muted?: boolean
  testId?: string
}

export type IntegrationCardFooterProps = {
  status: IntegrationCardIndicatorProps
  action?: IntegrationCardIndicatorProps
  rightContent?: ReactNode
  className?: string
}

const indicatorIcon = (kind: IntegrationCardIndicatorKind): ReactElement => {
  switch (kind) {
    case 'connected':
      return <SvgCheckFilled />
    case 'incomplete':
      return <SvgAlertCircledFilled />
    case 'loading':
      return <Processing />
    case 'manage':
      return <SvgUpdate />
    case 'connect':
    default:
      return <SvgLinked />
  }
}

export const IntegrationCardIndicator = ({
  kind,
  label,
  muted = false,
  testId,
}: IntegrationCardIndicatorProps): ReactElement => (
  <span
    className={cn('integration-card-indicator', kind, { muted })}
    data-testid={testId}
  >
    {kind !== 'manage' && indicatorIcon(kind)}
    {label}
    {kind === 'manage' && indicatorIcon(kind)}
  </span>
)

const IntegrationCardFooter = ({
  status,
  action,
  rightContent,
  className = '',
}: IntegrationCardFooterProps): ReactElement => (
  <div className={cn('IntegrationCardFooter', className)} css={style}>
    <IntegrationCardIndicator
      {...status}
      testId={status.testId ?? 'integration-card-status'}
    />
    {rightContent ??
      (action && (
        <IntegrationCardIndicator
          {...action}
          testId={action.testId ?? 'integration-card-action'}
        />
      ))}
  </div>
)

export default IntegrationCardFooter
